export const INIT_PAYMENT_FORM = 'BUS/INIT_BOOKING_PAYMENT_FORM';
export const SET_PAYMENT_MODE = 'BUS/SET_PAYMENT_MODE';
export const SET_RESERVATION_DATE_TIME = 'BUS/SET_RESERVATION_DATE_TIME';
export const SET_PAYMENT_METHOD = 'BUS/SET_PAYMENT_METHOD';

export function busPaymentFormSetPaymentMode(paymentMode) {
  return {
    type: SET_PAYMENT_MODE,
    paymentMode,
  };
}

export function busPaymentFormSetReservationDateTime(dateTime) {
  return {
    type: SET_RESERVATION_DATE_TIME,
    dateTime,
  };
}

export function busPaymentFormSetPaymentMethod(paymentMethod) {
  return {
    type: SET_PAYMENT_METHOD,
    paymentMethod,
  };
}
